module.exports = __webpack_public_path__ + "img/image5.faf34cfb.png";